if ($('.type-detail').length) {


(function () {
  function copyUpsellBanner() {
    var $banner = $('.p-image-wrapper .up-banner-productDetail-bellow_product_photo');
    var $target = $('.p-info-wrapper');

    if (!$banner.length || !$target.length) {
      return;
    }

    if ($target.find('.up-banner-productDetail-bellow_product_photo').length) {
      return;
    }

    $target.append($banner.clone(true, true));
  }

  function runCopyUpsellBanner() {
    setTimeout(copyUpsellBanner, 50);
  }

  $(function () {
    runCopyUpsellBanner();

    document.addEventListener('UpsellProductRendered', runCopyUpsellBanner);
    document.addEventListener('UpsellProductChanged', runCopyUpsellBanner);
    document.addEventListener('UpsellBannersRendered', runCopyUpsellBanner);
  });
})();
   /* document.addEventListener('ShoptetRatingModalOpened', function() {
        const productName = $('.p-detail-inner-header').first().find('h1').html() || '';
        const productNameAlt = $('.p-detail-inner-header').first().find('h1').text() || '';
        const $ratingWrap = $(this).closest('#ratingWrapper');
        const canRate = $('.ratingDialog #ratingWrapper').length;
        const productId = $('#product-detail-form meta[itemprop="productID"]').attr('content') || '';
        const ratingValueRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content');
        const ratingValue = ratingValueRaw ? ratingValueRaw.replace('.', ',') : 0;
        const ratingCountRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingCount"]').attr('content');
        const ratingCount = ratingCountRaw || 0;
        const popupContent = canRate;
        if($('.rating-star-description').length){
            $('#dialogFormRating .rating-stars-group').prepend(`
                <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
            `)
            $('#dialogFormRating #rating-stars-label span').html(`Zvolte počet hvězd. Vaše hodnocení pomůže ostatním zákazníkům s výběrem zboží. Hodnocení produktu je <strong>${ratingValue} z 5</strong>. Děkujeme.`)
            $('.ratingDialog #ratingWrapper').hide()
        }
        else{
            $('.ratingDialog #ratingWrapper').replaceWith(`
                <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
                <div class="ratingdone">
                    Děkujeme. U tohoto produktu jste již hlasovali. Aktuální hodnocení produktu je <strong>${ratingValue} z 5</strong>.
                </div>
            `)
           
        };
        
        $(function () {
            $('.rating-stars-wrapper').each(function () {
                var $wrapper = $(this);

                $wrapper.find('.rating-star').on('mouseenter', function () {
                    var value = parseInt($(this).find('input[name="score"]').val(), 10);

                    setRatingStars($wrapper, value);
                });

                $wrapper.find('input[name="score"]').on('change', function () {
                    var value = parseInt($(this).val(), 10);

                    setRatingStars($wrapper, value);
                });

                $wrapper.on('mouseleave', function () {
                    var checkedValue = parseInt($wrapper.find('input[name="score"]:checked').val(), 10);

                    if (checkedValue) {
                        setRatingStars($wrapper, checkedValue);
                    } else {
                        resetRatingStars($wrapper);
                    }
                });
            });

            function setRatingStars($wrapper, value) {
                $wrapper.find('.rating-star').each(function () {
                    var $star = $(this);
                    var starValue = parseInt($star.find('input[name="score"]').val(), 10);

                    $star.removeClass('full hoverEmpty');

                    if (starValue <= value) {
                        $star.addClass('full');
                    } else {
                        $star.addClass('hoverEmpty');
                    }
                });
            }

            function resetRatingStars($wrapper) {
                $wrapper.find('.rating-star').removeClass('full hoverEmpty');
            }
        });
         shoptet.modal.resize();
        setTimeout(function(){
           
        })

       
    });*/
    

 /* $('.product-top .star').each(function () {
    const $star = $(this);
    const $ratingWrap = $star.closest('.stars-wrapper');
    if ($star.hasClass('productRatingAction')) {
      $ratingWrap.attr('data-can-rate', '1');
    }
    $star.removeClass('productRatingAction');
  });
  $('.product-top .stars-wrapper').each(function () {
    const $ratingWrap = $(this);
    if (!$ratingWrap.attr('data-can-rate')) {
      $ratingWrap.attr('data-can-rate', '0');
    }
  });*/
/*
  $('html').on('click', '.product-top .stars-wrapper span', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $ratingWrap = $(this).closest('.stars-wrapper');
    const canRate = $ratingWrap.attr('data-can-rate') === '1';
    const productId = $('#product-detail-form meta[itemprop="productID"]').attr('content') || '';
    const productName = $('.p-detail-inner-header').first().find('h1').html() || '';
    const productNameAlt = $('.p-detail-inner-header').first().find('h1').text() || '';
    const ratingValueRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content');
    const ratingValue = ratingValueRaw ? ratingValueRaw.replace('.', ',') : 0;
    const ratingCountRaw = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingCount"]').attr('content');
    const ratingCount = ratingCountRaw || 0;
    const popupContent = canRate
      ? `
        <div class="customStarsWrap">
          <span class="customStar" data-productid="${productId}" data-score="1"></span>
          <span class="customStar" data-productid="${productId}" data-score="2"></span>
          <span class="customStar" data-productid="${productId}" data-score="3"></span>
          <span class="customStar" data-productid="${productId}" data-score="4"></span>
          <span class="customStar" data-productid="${productId}" data-score="5"></span>
        </div>
        <div class="customStarsText">Vyberte hodnocení</div>
      `
      : `
        <div class="customStarsAlreadyRated">
          <p>U tohoto produktu jste již hlasovali.</p>
        </div>
      `;

    $.colorbox({
      html: `
        <div class="colorboxPopupRatings">
          <div class="h3">Hodnocení produktu</div>
          <div class="h6"><img src="${$('.p-image .p-main-image').attr('href')}" alt="${productNameAlt.trim()}"><span>${productName.trim()}</span></div>
          <p>
            ${
              canRate
                ? `Zvolte počet hvězd. Vaše hodnocení pomůže ostatním zákazníkům s výběrem zboží. Hodnocení produktu je <strong>${ratingValue} z 5</strong>. Děkujeme.`
                : `Děkujeme. U tohoto produktu jste již hlasovali. Aktuální hodnocení produktu je <strong>${ratingValue} z 5</strong>.`
            }
          </p>

          ${popupContent}
        </div>
      `,
      height: '380px',
      width: '500px',
      maxWidth: '90%',
      maxHeight: '90%',
      onComplete: function () {
        initTooltips();
      }
    });

    return false;
  });*/

    var formatPriceDPH = $('.p-final-price-wrapper .price-final-holder').text().trim();
    var formatDPHprice = $('.p-final-price-wrapper .price-additional').text().replace(translation('bezDPH'), '').trim();
  
    if(formatPriceDPH === formatDPHprice){
        $('.p-info-wrapper .p-final-price-wrapper .price-additional').text(translation('osvobozeno'))
    }
    $('.p-detail-inner-header .p-code').insertAfter('.p-detail-info .stars-wrapper');
    
    (function() {
        $('.p-code .p-code-label').text(translation('kodLabel'))
        if($('.manufacturerDescription').length){

            var $marker = $('p:contains("#ShowMore#")');
            if (!$marker.length) return;
            var $prevParagraph = $marker.prev('p');
            var $contentAfter = $marker.nextAll();
            $contentAfter.hide();
            var $button = $('<button>', {
                class: 'show-more',
                text: translation('cistVice')
            });
           // console.log('aaaa')
        // $prevParagraph.append(' ').append($button);
            $marker.html($button);
            $('body').off('click', '.show-more, .show-less');

            $('body').on('click', '.show-more, .show-less', function (e) {
                e.preventDefault();
                var $btn = $(this);
                var $hiddenContent = $btn.closest('p').nextAll();
                
                if ($hiddenContent.is(':visible')) {
                    $hiddenContent.slideUp(450);
                    $btn
                        .removeClass('show-less')
                        .addClass('show-more')
                        .text(translation('cistVice'));
                } else {
                    $hiddenContent.slideDown(450);
                    $btn
                        .removeClass('show-more')
                        .addClass('show-less')
                        .text(translation('cistMene'));
                }
            });
        }
        $('.extended-description .detail-parameters tr').each(function () {
            var label = $(this).find('.row-header-label').text().trim();
            if (label.includes(translation('TypZbozi'))) {
                var value = $(this).find('td a').text().trim();
                if (!stavZbozi.includes(value)) {
                    $('.p-image').append('<span class="ilustationPicture">'+translation('ilustracni')+'</span>')
                }
            }
            if(label.includes(translation('TypZbozi'))){
                var value = $(this).find('td a').text().trim();
                if (!stavZbozi.includes(value)) {
                    cached = sessionStorage.getItem('repas');
                    if (cached) {
                        $('#productsAlternative').before(cached);
                    } else {
                        $.ajax({
                            url: '/',
                            type: 'GET',
                            dataType: 'html',
                            success: function (response) {
                                const doc = $('<div>').html(response);
                                const repas = doc.find('.repas').first();

                                if (!repas.length) return;

                                const repasHtml = repas.prop('outerHTML');

                                sessionStorage.setItem('repas', repasHtml);

                                $('.cbreadWrapper').after(repasHtml);
                                

                            },
                            error: function () {
                                console.warn('Nelze načíst repas z homepage');
                            }
                        }).done(function(){
                            initRepasSlider();
                        });
                    }
                }

            }
        });

    
        const availabilityTextDetail = $('.p-info-wrapper .availability-value > span:not(.availability-amount)')
            .text()
            .trim()
            .toLowerCase();
        $('.p-info-wrapper  .availability-amount').each(function(){
            $(this).text(' '+$(this).text().replace('(', '').replace(')', '').replace('>', '> ')).attr('style', $('.p-info-wrapper  .availability-label').attr('style'))
        })
        const deliveryDate = getDeliveryDateByAvailability(availabilityTextDetail);
        if (!deliveryDate) return;
        const formatted = formatDeliveryDate(deliveryDate);
        if(!$('.p-info-wrapper .availability-value .deliveryDate').length){
            $('.p-info-wrapper .availability-value').append(
            `<div class="deliveryDate" style="${$('.p-info-wrapper  .availability-label').attr('style')}">, ${formatted}</div>`
        );
        }
    })();

var jeVyjmut = vyjmuti.includes(
    parseInt(getShoptetDataLayer('customer')?.groupId || 0, 10)
);

if ($('#productsAlternative').length) {

    var $products = $('#productsAlternative .product');
    var grouped = {};

    Object.keys(productTabsMap).forEach(function(tab){
        grouped[tab] = [];
    });

    grouped["Ostatní"] = [];

    $products.each(function(){

        var $p = $(this);
        var sku = $p.find('[data-micro="sku"]').text().trim();

        if (jeVyjmut && vyjmutiSKUS.includes(sku)) {
            return; // continue
        }

        var name = $p.find('[data-micro="name"]').text().trim();
        var price = $p.find('.price-final strong').text().trim();
        var desc = $p.find('.p-desc').text().trim();
        var assigned = false;

        Object.keys(productTabsMap).forEach(function(tab){

            const skuConfig = findProductTabSkuConfig(productTabsMap[tab], sku);

            if (skuConfig) {
                grouped[tab].push({
                    name: name,
                    price: price,
                    desc: desc,
                    sku: sku,
                    url: skuConfig.url
                });

                assigned = true;
            }

        });

        if (!assigned) {
            grouped["Ostatní"].push({
                name: name,
                price: price,
                desc: desc,
                sku: sku,
                url: null
            });
        }

    });
    var html = '<div class="custom-accordion">';

    Object.keys(grouped).forEach(function(tab) {
        if (!grouped[tab].length) return;

        const isOpen = productTabsMap[tab]?.open;
        const selectType = productTabsMap[tab]?.type || 'multi';

        html += `
            <div class="accordion-item ${isOpen ? 'active' : ''}" data-select-type="${selectType}">
                <div class="accordion-header">${tab}</div>
                <div class="accordion-body" ${isOpen ? '' : 'style="display:none;"'}>
        `;

        grouped[tab].forEach(function(p) {
            var infoHtml = '';

            if (p.url) {
                infoHtml = `
                    <span class="info acc-product-popup-info"
                        data-url="${p.url}"
                        title="Více informací"></span>
                `;
            } else if (p.desc) {
                infoHtml = `
                    <span class="info show-tooltip"
                        data-original-title="${p.desc}"></span>
                `;
            }

            html += `
                <div class="acc-product" data-sku="${p.sku}" data-price="${parsePriceUniversal(p.price)}">
                    <div class="acc-name">
                        <span class="name">${p.name}</span>
                        ${infoHtml}
                    </div>
                    <div class="acc-price">+${p.price}</div>
                </div>
            `;
        });

        html += `
                </div>
            </div>
        `;
    });

    html += '</div>';

    $('.p-info-wrapper').append(html);
}

if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
    $('.p-image-wrapper').addClass('haveThumbnails');

    if (!$('.p-image-wrapper .p-image .arrow-prev').length) {
        $('.p-image-wrapper .p-image').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
    }

    $('body')
        .off('click.productImageArrows')
        .on('click.productImageArrows', '.arrow-prev, .arrow-next', function () {
            var isNext = $(this).hasClass('arrow-next');

            changeProductImage(isNext);
        });

    initProductImageSwipe();
    initThumbnailsSwipe();

    function changeProductImage(isNext) {
        var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.show360image');
        var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
        var totalThumbnails = thumbnails.length;

        if (!totalThumbnails) {
            return;
        }

        var currentIndex = thumbnails.index(highlightedThumbnail);

        thumbnails.removeClass('highlighted');

        if (highlightedThumbnail.length === 0 || currentIndex < 0) {
            highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
        } else {
            currentIndex = isNext
                ? (currentIndex + 1) % totalThumbnails
                : (currentIndex - 1 + totalThumbnails) % totalThumbnails;

            highlightedThumbnail = thumbnails.eq(currentIndex);
        }

        highlightedThumbnail.addClass('highlighted');

        setTimeout(function () {
            updateMainImage(highlightedThumbnail);
            scrollThumbnailIntoView(highlightedThumbnail);
        }, 10);
    }

    function updateMainImage(highlightedThumbnail) {
        var findHighlighted = highlightedThumbnail.attr('href');
        var findHighlightedAlt = highlightedThumbnail.find('img').attr('alt') || highlightedThumbnail.attr('data-alt') || '';

        if (!findHighlighted) {
            return;
        }

        $('.p-image a.p-main-image')
            .attr('href', findHighlighted)
            .find('img')
            .attr({
                src: findHighlighted,
                alt: findHighlightedAlt
            });
    }

function scrollThumbnailIntoView($thumbnail) {
    var $inner = $('.p-thumbnails-inner');
    var $wrap = $('.p-thumbnails');

    if (!$thumbnail.length || !$inner.length || !$wrap.length) {
        return;
    }

    var thumbLeft = $thumbnail.position().left;
    var thumbWidth = $thumbnail.outerWidth(true);
    var wrapWidth = $wrap.width();
    var currentLeft = parseInt($inner.css('left'), 10) || 0;

    var visibleLeft = -currentLeft;
    var visibleRight = visibleLeft + wrapWidth;

    var newLeft = currentLeft;

    if (thumbLeft < visibleLeft) {
        newLeft = -thumbLeft;
    } else if (thumbLeft + thumbWidth > visibleRight) {
        newLeft = -(thumbLeft + thumbWidth - wrapWidth);
    }

    var $items = $inner.find('a.p-thumbnail, a.show360image');
    var minLeft = 0;

    if ($items.length) {
        var $last = $items.last();
        var lastRight = $last.position().left + $last.outerWidth(true);

        minLeft = Math.min(0, wrapWidth - lastRight);
    }

    if (newLeft > 0) newLeft = 0;
    if (newLeft < minLeft) newLeft = minLeft;

    $inner.css('left', newLeft + 'px');

    $wrap
        .toggleClass('overflow-prev', newLeft < -2)
        .toggleClass('overflow-next', newLeft > minLeft + 2);
}

function getThumbnailsMinLeft($wrap, $inner) {
    var $items = $inner.find('a.p-thumbnail, a.show360image');

    if (!$items.length) return 0;

    var $last = $items.last();
    var lastRight = $last.position().left + $last.outerWidth(true);
    var wrapWidth = $wrap.outerWidth();

    return Math.min(0, wrapWidth - lastRight);
}

    function initProductImageSwipe() {
        var startX = 0;
        var startY = 0;
        var currentX = 0;
        var currentY = 0;
        var isTouching = false;
        var minSwipeDistance = 50;
        var maxVerticalDistance = 70;

        $('body')
            .off('touchstart.productImageSwipe')
            .on('touchstart.productImageSwipe', '.p-image-wrapper .p-image', function (e) {
                var touch = e.originalEvent.touches[0];

                startX = touch.clientX;
                startY = touch.clientY;
                currentX = startX;
                currentY = startY;
                isTouching = true;
            });

        $('body')
            .off('touchmove.productImageSwipe')
            .on('touchmove.productImageSwipe', '.p-image-wrapper .p-image, .p-thumbnails-wrapper', function (e) {
                if (!isTouching) {
                    return;
                }

                var touch = e.originalEvent.touches[0];

                currentX = touch.clientX;
                currentY = touch.clientY;
            });

        $('body')
            .off('touchend.productImageSwipe')
            .on('touchend.productImageSwipe', '.p-image-wrapper .p-image, .p-thumbnails-wrapper', function () {
                if (!isTouching) {
                    return;
                }

                isTouching = false;

                var diffX = currentX - startX;
                var diffY = currentY - startY;

                if (Math.abs(diffX) < minSwipeDistance) {
                    return;
                }

                if (Math.abs(diffY) > maxVerticalDistance) {
                    return;
                }

                if (diffX < 0) {
                    // swipe doleva → další obrázek
                    changeProductImage(true);
                } else {
                    // swipe doprava → předchozí obrázek
                    changeProductImage(false);
                }

                startX = 0;
                startY = 0;
                currentX = 0;
                currentY = 0;
            });
    }

    function initThumbnailsSwipe() {
        $('.p-thumbnails').each(function () {
            var wrap = this;
            var $wrap = $(wrap);
            var $inner = $wrap.find('.p-thumbnails-inner').first();

            if (!$inner.length) return;
            if (wrap.dataset.thumbnailsSwipeBound === '1') return;

            wrap.dataset.thumbnailsSwipeBound = '1';

            var startX = 0;
            var startY = 0;
            var startLeft = 0;
            var currentLeft = 0;
            var isDragging = false;
            var didMove = false;

        function getMinLeft() {
            return getThumbnailsMinLeft($wrap, $inner);
        }
        function clampLeft(left) {
            var minLeft = getMinLeft();

            if (left > 0) return 0;
            if (left < minLeft) return minLeft;

            return left;
        }

        function setLeft(left) {
            currentLeft = clampLeft(left);
            $inner.css('left', currentLeft + 'px');

            $wrap
                .toggleClass('overflow-prev', currentLeft < -2)
                .toggleClass('overflow-next', currentLeft > getMinLeft() + 2);
        }

        wrap.addEventListener('touchstart', function (e) {
            if (!e.touches || !e.touches.length) return;

            var touch = e.touches[0];

            startX = touch.clientX;
            startY = touch.clientY;
            startLeft = parseInt($inner.css('left'), 10) || 0;
            isDragging = true;
            didMove = false;
        }, { passive: true });

        wrap.addEventListener('touchmove', function (e) {
            if (!isDragging || !e.touches || !e.touches.length) return;

            var touch = e.touches[0];
            var diffX = touch.clientX - startX;
            var diffY = touch.clientY - startY;

            // necháme normální vertikální scroll stránky
            if (Math.abs(diffY) > Math.abs(diffX)) {
                return;
            }

            didMove = Math.abs(diffX) > 5;

            // zabrání posunu celé stránky při horizontálním swipu
            e.preventDefault();

            setLeft(startLeft + diffX);
        }, { passive: false });

        wrap.addEventListener('touchend', function () {
            isDragging = false;

            setTimeout(function () {
                didMove = false;
            }, 50);
        }, { passive: true });

        // zabrání kliknutí na thumbnail, když šlo o tah
        $wrap.on('click.thumbnailsSwipe', 'a.p-thumbnail', function (e) {
            if (didMove) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });

        setLeft(parseInt($inner.css('left'), 10) || 0);
    });
}

}
    
    $(document).ready(function () {
            var customLineCart = `
        <div class="left">
            <img src="${$('.p-image a.p-main-image').attr('href')+'" alt="'+$('.p-detail-inner>.p-detail-inner-header>h1').text()}">
        </div>
        <div class="right">
            <div class="priceStock">
                <div class="pricesLine">${$('.p-final-price-wrapper').html()}</div>
                <div class="availabilityCustom">${$('.availability-value').html()}</div>
            </div>
            <div class="buyButton"><span class="customBtnCart btn btn-conversion" data-priceId="${$('#product-detail-form>input[name="priceId"]').attr('value')}">${translation('koupit')}</div>
        </div>
    `
    $('body.mobile').append('<div class="detailFixedCart" style="display:none;"><div class="container">'+customLineCart+'</div></div>')
    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop(); // aktuální pozice scrollu
        var triggerOffset = $('.social-buttons-wrapper').offset().top //+ $('.social-buttons-wrapper').outerHeight();
        if($('body').hasClass('mobile')){
            if (scrollTop >= triggerOffset) {
            $('.detailFixedCart').fadeIn();
            } else {
            $('.detailFixedCart').fadeOut();
            }
        }
        else{

        }
    });
    if($('#ratingTab').length){
        $('#ratingTab .rate-average-wrap').prepend(`<span class="h3">${translation('hodnoceniProduktu')}<i> ${$('.p-detail>.p-detail-inner>.p-detail-inner-header h1').html()}</i></span>`)
    }
      /* $('#tab-content').append(`
            <div id="ratingTab" class="tab-pane fade" role="tabpanel" data-editorid="rating">
                <div id="ratingWrapper" class="rate-wrapper unveil-wrapper" data-parent-tab="ratingTab">
                <div class="rate-wrap row">
                    <div class="rate-average-wrap col-xs-12 col-sm-6">
                        <div class="rate-average-inner" data-testid="wrapRatingAverage">
                            <span class="rate-average" data-testid="textRatingAverage">
                                ${$('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content') || 0}
                            </span>
                            <span class="rate-star-wrap" data-testid="wrapRatingAverageStars">
                            ${$('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info .stars-wrapper').html()}
                        </span>
                    </div>
                </div>   
            </div> 
            
        `)*/
       /* $('html').on('click', '.p-detail-inner .stars .star', function(){
            var counterRate = $('#product-detail-form span[itemprop="aggregateRating"] meta[itemprop="ratingValue"]').attr('content') || 0;
            var htmlRate = $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info .stars-wrapper').html();
            $('#tab-content #ratingTab .rate-average').html(counterRate);
            $('#tab-content #ratingTab .rate-star-wrap').html(htmlRate);
        })*/
        var brandImage = $('a[data-testid="productCardBrandName"] span').text().trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-');;
        var brandName = $('.product-top>.col-xs-12:not(.col-lg-6) a[data-testid="productCardBrandName"] span').text();
        var brandLink = $('.product-top>.col-xs-12:not(.col-lg-6) a[data-testid="productCardBrandName"]').attr('href');
        var topTitle = $('.p-detail>.p-detail-inner>.p-detail-inner-header h1').text();
        $('a[data-testid="productCardBrandName"]').html(`
        <div class="brand">
                <a href="${brandLink}">
                    <img
                        src="/user/documents/sablona-nemazat/logaZnacek/${brandImage}.png?v=${new Date().getMinutes()}"
                        alt="${topTitle}"
                        onerror="this.outerHTML='<span class=\\'brandText\\'>${translation('znacka')}: ${brandName}</span>'"
                    >
                </a>
        </div>
        `);

        if ($('.p-gifts-wrapper').length) {
            var $wrapper = $('.p-gifts-wrapper');
            var $gifts = $wrapper.find('.p-gift');

            var newHtml = `
                <div class="custom-gift">
                    <div class="custom-gift-heading">
                        ${translation('darekZdarma')}
                    </div>
                    <div class="custom-gift-list"></div>
                </div>
            `;

            $wrapper.html(newHtml);

            $gifts.each(function () {
                var $gift = $(this);

                var $img = $gift.find('.p-gift-image').first().clone();
                var $giftName = $gift.find('.p-gift-name a').first().clone();

                $giftName.contents().filter(function () {
                    return this.nodeType === 3;
                }).each(function () {
                    this.textContent = this.textContent.replace('+', ' ').trim();
                });

                $giftName.contents().first().wrap('<span class="gift-title"></span>');

                var $item = $(`
                    <div class="custom-gift-item">
                        <div class="custom-gift-left"></div>
                        <div class="custom-gift-right">
                            <div class="custom-gift-name"></div>
                        </div>
                    </div>
                `);

                $item.find('.custom-gift-left').append($img);
                $item.find('.custom-gift-name').append($giftName);

                $wrapper.find('.custom-gift-list').append($item);
            });
        }
        const customer = getShoptetDataLayer('customer');
        const priceListId = customer?.priceListId;
        const defaultWarranty = $('meta[itemprop="warranty"]').attr('content');
        const warranty = warrantyMap[priceListId] || defaultWarranty;
        $('.p-info-wrapper').append(`
            <div class="warranty">
                <div class="warrantyInner">${translation('zaruka')}: ${warranty}
            </div>
        `);
        $('.extended-description table tr:contains('+translation("zaruka")+') td').text(warranty)
        


        setTimeout(function(){
            $('.p-info-wrapper .warranty').prepend($('.p-info-wrapper .dkLabComparerDiv'));
        }, 350)
        
        

        
        $('a.link-icon.chat span').text(translation('dotazkProduktu'))
        $('a.link-icon.watchdog span').text(translation('hlidat'))
        $('.p-image').append($('.product-top>.col-xs-12:not(.col-lg-6)>.p-detail-info .flags').clone())
        $('.p-info-wrapper').append($('.p-detail .p-detail-inner .p-detail-inner-header').clone(), $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info').clone());
        $('.p-info-wrapper a.chevron-after.chevron-down-after').text(translation('viceInformaci'));
        if($('.p-final-price-wrapper .price-standard').length){
            $('.p-final-price-wrapper').prepend('<span class="title">' + akcniCena+ '</span>');
            $('.p-final-price-wrapper').addClass('actionPrice');
        }

        $('.extended-description h3').text(translation('parametryProduktu'));
        $('.extended-description h3').first().append('<span>' + $('.p-detail-inner-header h1').html() + '</span>');
        if($('.extended-description').length){
            $('.extended-description').attr('id', 'extended-description')
        }
        $('#ratingTab').before('<div class="contactUs"><div class="left"><div class="text"></div></div><div class="right"></div></div>')
        $('.contactUs .left').prepend($('footer#footer .helpFooter .personLine').clone());
        $('.contactUs .right').append($('footer#footer .helpFooter .mobileCenter').clone().find('a').text(translation('vsechnyKontakty')));
        $('.contactUs .left .text').append($('footer#footer .helpFooter .online').clone());
        $('.contactUs .left').append($('footer#footer .helpFooter .online').clone());
        $('.contactUs .left .text').append('<span class="js">' + translation('jsmeTu') + '</span>');
        $('.contactUs .left .text').append('<span class="po">' + translation('poradit') + '</span>');
        $('.contactUs .right').append($('footer#footer .helpFooter ul').clone());
        $('#ratingsList>.vote-wrap>.vote-header').append('<span class="overenyZakaznik">'+translation('overeneHodnoceni')+'</span>')
        $('#ratingWrapper .rate-list').each(function () {
            let rate = parseInt($(this).find('.rate-value').text(), 10);
            $(this).find('.stars').empty();
            for (let i = 0; i < rate; i++) {
                $(this).find('.stars').append('<span class="star star-on"></span>');
            }
            for (let i = rate; i < 5; i++) {
                $(this).find('.stars').append('<span class="star star-off"></span>');
            }
        });
        $(function () {
        splitProductParameters(parameterMap);
       
        });


        $('#description').after('<div class="cbreadWrapper"><ul class="c_breadcrumbs"></ul></div>');
        $('.cbreadWrapper').prepend('<span>' + translation('najdeteZde') + '</span>');
        $('.breadcrumbs span').not(':first').each(function () {
            const link = $(this).find('a').first();

            if (!link.length) return;

            $('.c_breadcrumbs').append(
                $('<li></li>').append(link.clone())
            );
        });
        $('#productsAlternative').prepend('<span class="h3">' + translation('nepotrebujete') + ' </span>')
        /*const faqHtml = `
        <div class="faq">
            <span class="h3">Často kladené dotazy</span>

            <div class="faq-item">
                <button class="faq-question">
                    Odolný a praktický design?
                </button>
                <div class="faq-answer">
                    <p>
                        Mějte své nákupy pod kontrolou. Už žádné hledání v e-mailech a zmatky
                        s čísly objednávek. Všechny své nákupy a jejich stav najdete přehledně
                        na jednom místě. Spravujte své objednávky snadno a pohodlně.
                    </p>
                </div>
            </div>

            <div class="faq-item">
                <button class="faq-question">
                    Odolný a praktický design?
                </button>
                <div class="faq-answer">
                    <p>
                        Mějte své nákupy pod kontrolou. Už žádné hledání v e-mailech a zmatky
                        s čísly objednávek. Všechny své nákupy a jejich stav najdete přehledně
                        na jednom místě. Spravujte své objednávky snadno a pohodlně.
                    </p>
                </div>
            </div>
        </div>
    `;
        $('#ratingTab').before(faqHtml);*/
       
        if($('.p-info-wrapper .shipping-options').length){
            $('.availability-value').after('<div class="deliveryLabel"></div>');
            $('.deliveryLabel').append($('.p-info-wrapper .shipping-options'))
        }


        var faqUrl = getFaqScrapeUrl();

let tabsHtml = '';

tabsHtml += `
    <li class="shp-tab" data-testid="tabextended" data-width="">
        <a href="#extended-description" class="shp-tab-link" aria-expanded="false">
            ${translation('parametryProduktu')}
        </a>
    </li>
`;

if (faqUrl && $('#ratingTab').length) {
    tabsHtml += `
        <li class="shp-tab" data-testid="tabfaq" data-width="">
            <a href="#faq" class="shp-tab-link" aria-expanded="false">
                ${translation('faq')}
            </a>
        </li>
    `;

    loadFaqContent();
}

$('#p-detail-tabs .shp-tab').first().after(tabsHtml);
          

        initTooltips();
        var productData = getShoptetDataLayer('product');
        var price = parseFloat(productData.priceWithVat);
        if (price < 1000) {
            $('.installmentBox').hide();
            return;
        }
        var coefficient = 0;
        var months = 0;

        if (price <= 5000) {
            coefficient = 5.237330;
            months = 24;
        } else {
            coefficient = 2.57231;
            months = 72;
        }
        var monthlyPayment = Math.ceil(price * (coefficient / 100));
        var linkSplatkyNew = $('#HcCalculater a').attr('href')
        if($('#HcCalculater').length){
            $('.p-info-wrapper').append(
                '<div class="installmentBox">' +
                    '<p class="textHomeCredit">'+translation('splatky')+' <strong> '+translation('od')+' ' + Number(monthlyPayment).ShoptetFormatAsCurrency() + '</strong> '+translation('mesicne')+'</p>' +
                    '<p><a href="'+linkSplatkyNew+'">'+translation('spocitatSplatky')+'</a></p>' +
                '</div>'
            );
        }
        
    });

    var productCode = getShoptetDataLayer('product').code;

    $.ajax({
        url: 'https://www.akce-incomputer.cz/api-get-prices.php',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
            Source: 'SK',
            data: [{ code: productCode }]
        }),
        success: function (response) {
            if (!response || !response.data) return;
            var item = response.data.find(p => p.code === productCode);
            if (!item) return;
            applyPricesToProductInfoWrapper($('.p-info-wrapper'), item);
        },
        error: function (xhr) {
            console.error('AJAX chyba ceny:', xhr.responseText);
        }
    }).done(function(){
        initTooltips();
    });

    
   

    $('li[data-testid="tabDescription"] a').text(translation('popisProduktu'))
  
    $('.basic-description h3').first().text(translation('popisProduktu') + $('.p-detail-inner-header h1').text());
   
        var $source = $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info .stars-wrapper .star');
        var $newSpan = $('<span class="stars star-list"></span>');
        var ratingCount = $('[itemprop="aggregateRating"] [itemprop="ratingCount"]').attr('content');
        var ratingCountNumber = ''
        if (ratingCount) {
            ratingCountNumber += '' + ratingCount + '';
        }
        else{
            ratingCountNumber = '0'
        }

        $source.each(function () {
            var classes = this.className
                .split(' ')
                .filter(c => c === 'star-on' || c === 'star-half' ||  c === 'star-off');
            if (classes.length) {
                $newSpan.append('<span class="star ' + classes.join(' ') + '"></span>');
            }
        });
         $('#p-detail-tabs .shp-tab[data-testid="tabRating"] a').html(`${translation('hodnoceni')} (${ratingCountNumber}) ${$newSpan.prop('outerHTML')}`)
        
    
    $('#p-detail-tabs li a').removeAttr('role').removeAttr('data-toggle');
    if($('.p-detail>.products-related-header').length){
        $('.products-related.products-additional').prev('.products-related-header').attr('id', 'productsRelated')
         $('#p-detail-tabs .shp-tab').last().after(`
            <li class="shp-tab" data-testid="tabaouvisejici" data-width="">
                <a href="#productsRelated" class="shp-tab-link" aria-expanded="false">${translation('souvysejiciProdukty')}</a>
            </li>
    `)
    };
    $('.shp-tabs-row').prepend('<div class="image"><img src="'+$('.p-image a.p-main-image').attr('href')+'" alt="'+$('.p-detail-inner>.p-detail-inner-header>h1').text()+'"></div>')
    if($('.p-info-wrapper .add-to-cart').length){
        var addCart = `<span class="customBtnCart btn btn-conversion" data-priceId="${$('#product-detail-form>input[name="priceId"]').attr('value')}">${translation('VlozitDoKosiku')}</div>`
    }
    else{
        var addCart = ''
    }
    
    $('.shp-tabs-row .shp-tabs-holder').prepend(`
        <div class="customLineDetail">
            <div class="left">
                <div class="h6">${$('.p-detail-inner>.p-detail-inner-header>h1').html()}</div>
                <div class="availabilityCustom">${$('.availability-value').html()}</div>
            </div>
            <div class="right">
                <div class="pricesLine">${$('.p-final-price-wrapper').html()}</div>
                ${addCart}
            </div>
        </div>    
    `)
         
    
    setTimeout(function(){
        $('#p-detail-tabs').append($('.shp-tabs-row .hidden-links').html());
      
    }, 350);
    
    
    

}




$('html').on('click', '.customBtnCart', function(){
    shoptet.cartShared.addToCart({priceId: $(this).attr('data-priceId'), amount: 1});
})



function applyParameterSectionLimits(parameterMap) {
  $('.paramsSection').each(function () {
    const $section = $(this);
    const sectionKey = $section.data('section');
    const $rows = $section.find('tbody tr');

    if (!$rows.length) {
      $section.hide();
      return;
    }

    let visibleCount = 5;

    if (
      parameterMap[sectionKey] &&
      parameterMap[sectionKey].visibleCount
    ) {
      visibleCount = parameterMap[sectionKey].visibleCount;
    }

    if (sectionKey === 'ostatni') {
      visibleCount = 5;
    }

    if ($rows.length <= visibleCount) {
      return;
    }

    $rows.each(function (index) {
      if (index >= visibleCount) {
        $(this).addClass('paramHiddenRow').hide();
      }
    });

    $section.append(`
      <div class="paramShowMoreWrap">
        <span class="paramShowMore" role="button">
          ${translation('zobrazitDalsiVMenu')}
        </span>
      </div>
    `);
  });
}

$(document).on('click', '.paramShowMore', function () {
  const $button = $(this);
  const $section = $button.closest('.paramsSection');
  const isExpanded = $section.hasClass('isExpanded');

  if (isExpanded) {
    $section.find('.paramHiddenRow').hide();
    $section.removeClass('isExpanded');
    $button.closest('.paramShowMoreWrap').removeClass('isExpandedwrap')
    $button.text(translation('zobrazitDalsiVMenu')).removeClass('isExpandedButton');
  } else {
    $section.find('.paramHiddenRow').show();
    $section.addClass('isExpanded');
    $button.closest('.paramShowMoreWrap').addClass('isExpandedwrap')
    $button.text(translation('zobrazitMene')).addClass('isExpandedButton');
  }
});

function splitProductParameters(parameterMap) {

  const $sourceTable = $('.extended-description .detail-parameters');
  if (!$sourceTable.length) return;

  const $container = $('<div class="paramsContainer"></div>');
  $sourceTable.before($container);

  // 🔹 Box pro Top vlastnosti (nahoře)
  const $topWrapper = $('<div class="topFeaturesWrapper"></div>');
  $('.p-info-wrapper').append($topWrapper);

  $.each(parameterMap, function (key, section) {
    $container.append(`
      <div class="paramsSection" data-section="${key}">
        <h3>${section.title}</h3>
        <table class="paramsTable">
          <tbody></tbody>
        </table>
      </div>
    `);
  });

  $container.append(`
    <div class="paramsSection" data-section="ostatni">
      <h3>Ostatní</h3>
      <table class="paramsTable">
        <tbody></tbody>
      </table>
    </div>
  `);

  function getSectionKey(label) {
    label = label.toLowerCase();

    for (const key in parameterMap) {
      if (parameterMap[key].keywords.some(k =>
        label.includes(k.toLowerCase())
      )) {
        return key;
      }
    }
    return 'ostatni';
  }

  $sourceTable.find('tbody tr').each(function () {

    const $row = $(this);
    const label = $row.find('th').text().trim();
    const value = $row.find('td').text().trim();

    if (!label) return;
    
    if (label.toLowerCase().includes(translation('cenavkc'))) {
     
         $row.hide();
          return;
    }
    // 🔥 1️⃣ Pokud je to "Top vlastnosti"
    if (label.toLowerCase().includes('top vlastnosti')) {

    if (value.length) {

        const features = value.split(';');

        $.each(features, function (i, feature) {

            const cleanFeature = feature.trim();
            if (!cleanFeature.length) return;

            const featureClass = slugify(cleanFeature);
            const config = featureConfig[featureClass] || {};

    let iconHtml = '';
    let contentStart = '';
    let contentEnd = '';
    let featureContent = cleanFeature;

    // 🔹 BARVA
    if (config.type === 'color') {

        iconHtml =
            '<div class="colorBadge">' +
                '<span style="' +
                    'background:' + config.background + ';' +
                    (config.border ? 'border:' + config.border + ';' : '') +
                '"></span>' +
            '</div>';

    } else {

        const iconFile = config.icon || featureClass;

        iconHtml =
            '<div class="img">' +
                '<img src="/user/documents/sablona-nemazat/topvlastnosti/' + iconFile + '.svg" ' +
                'alt="' + cleanFeature + '" ' +
                'onerror="this.onerror=null; this.src=\'/user/documents/sablona-nemazat/topvlastnosti/zastupna.png?1\';">' +
            '</div>';
    }

    // 🔹 Tooltip jen pokud existuje
    if (config.tooltip) {
        featureContent +=
            ' <span class="info show-tooltip" data-original-title="' +
            config.tooltip +
            '"></span>';
    }

    // 🔹 Link jen pokud existuje
    if (config.link) {
        contentStart = '<a href="' + config.link + '" class="topFeatureLink">';
        contentEnd = '</a>';
    }

    $topWrapper.append(
        '<div class="topFeatureItem ' + featureClass + '">' +
            iconHtml +
            contentStart +
            featureContent +
            contentEnd +
        '</div>'

                );

            });
        }

        $row.hide();
        return;
    }

    // 🔹 Klasické dělení do sekcí
    const sectionKey = getSectionKey(label);

    $container
      .find(`.paramsSection[data-section="${sectionKey}"] tbody`)
      .append($row);

  });

  const isNotebookCategory = $('#navigation-1 a[itemprop="item"] span[itemprop="name"]')
  .text()
  .trim()
  .toLowerCase() === kategorieNotebooky;

    if (isNotebookCategory) {
    const $accessoriesSection = $container.find('.paramsSection[data-section="prislusenstvi"] tbody');

    const hasPackageContent = $container.find('th').filter(function () {
        return $(this).text().trim().toLowerCase() === translation('obsahbaleni');
    }).length > 0;

    if (!hasPackageContent) {
        $accessoriesSection.append(`
        <tr>
            <th>${translation('obsahbaleni')}</th>
            <td>${translation('nabijeciadapter')}</td>
        </tr>
        `);
    }
}
applyParameterSectionLimits(parameterMap);


  // smaž prázdné sekce
  $container.find('.paramsSection').each(function () {
    if (!$(this).find('tbody tr').length) {
      $(this).remove();
    }
  });

  $sourceTable.hide();
}

function normalizePath(path) {
    if (!path) return null;
    return path.endsWith('/') ? path : path + '/';
}

function getFaqScrapeUrl() {
    let $target = $('.breadcrumbs > span:nth-last-child(2) a');
    let rawPath = $target.attr('href');
    if (rawPath) {
        const path = normalizePath(rawPath);
        if (FAQ_SCRAPE_MAP[path]) {
            return FAQ_SCRAPE_MAP[path];
        }
    }
    const fallbackPath = normalizePath($('#navigation-1 > a').attr('href'));
    return FAQ_SCRAPE_MAP[fallbackPath] ?? null;
}

function loadFaqContent() {

    const faqUrl = getFaqScrapeUrl();
    if (!faqUrl || !$('#ratingTab').length) return;

    $.get(faqUrl, function (response) {

        const $doc = $('<div>').html(response);
        const $faqContent = $doc.find('.news-item-detail .text');

        if (!$faqContent.length) return;

        const faqHtml = `
            <div class="faq" id="faq">
                <span class="h3">Často kladené dotazy</span>
                ${$faqContent.html()}
            </div>
        `;

        $('#tab-content .contactUs').before(faqHtml);

    }).fail(function () {
        console.error('Chyba při načítání FAQ');
    });
}

function applyPricesToProductInfoWrapper($product, price) {
   // console.log(price)
   // console.log($product)
    if (!isCustomerNotRegistered()) return;
    if (!price.price_login) return;
    var basePrice = getShoptetDataLayer('product').priceWithVat
      //  console.log(basePrice)
    if (!basePrice || price.price_login >= basePrice) return;

    var $priceWrapper = $product.find('.p-final-price-wrapper');
    if (!$priceWrapper.length) return;
    if ($product.find('.loginPrice').length) return;
    var html = `
        <div class="loginPrice">
            <strong class="price-login">
                ${formatPrice(price.price_login)}
            </strong>
            <span class="title">
                ${translation('pro')} 
                <a href="${registrovaneUrl}">
                    ${translation('registrovane')}
                </a>
            </span>
            <span class="info show-tooltip" 
                  data-original-title="${tooltipText}">
            </span>
        </div>
    `;
    $priceWrapper.after(html);
}

$('html').on('click', '.accordion-header', function(){
        var $item = $(this).closest('.accordion-item');
        if ($item.hasClass('active')) {
            $item.removeClass('active');
            $item.find('.accordion-body').slideUp(200);
        } else {
            $('.accordion-item').removeClass('active');
            $('.accordion-body').slideUp(200);
            $item.addClass('active');
            $item.find('.accordion-body').slideDown(200);
        }
});

$('html').on('click', '.acc-product', function () {
    var $product = $(this);
    var $group = $product.closest('.accordion-item');
    var selectType = $group.data('select-type');
    if (selectType === 'single') {
        if ($product.hasClass('activeAcc')) {
            $product.removeClass('activeAcc');
        } else {
            $group.find('.acc-product').removeClass('activeAcc');
            $product.addClass('activeAcc');
        }
    } else {
        $product.toggleClass('activeAcc');
    }
    updatePrice();
});

$('html').on('click', '.acc-product .info', function (e) {
    e.preventDefault();
    e.stopPropagation();
});

$(document).on('submit', '#product-detail-form', function () {
    const baseProductCode = $('#product-detail-form meta[itemprop="sku"]').attr('content') || null;
    setTimeout(function () {
        let addons = [];
        $('.custom-accordion .acc-product.activeAcc').each(function () {
            var sku = $(this).data('sku');
            if (!sku) return;
            shoptet.cartShared.addToCart({
                productCode: sku,
                amount: 1
            }, true);
            addons.push({
                sku: sku,
                amount: 1
            });
        });
        const record = {
            id: Date.now(),
            baseProductCode: baseProductCode,
            addons: addons,
            createdAt: new Date().toISOString()
        };
        let storage = JSON.parse(localStorage.getItem('productAddons') || '[]');
        storage.push(record);
        localStorage.setItem('productAddons', JSON.stringify(storage));
       // console.log('✅ Uloženo do storage:', record);
    }, 300);
});
/*
$('html').on('click', '.p-detail-info .stars-wrapper', function(e){
    e.preventDefault();
    e.stopImmediatePropagation();
    var starsHtml = $('.p-detail .p-detail-inner .product-top .col-xs-12:not(.col-lg-6) .p-detail-info .stars-wrapper').html();
    var content = `
        <div class="custom-rating-popup">
            <h3>Přidat hodnocení</h3>
            <div class="your-rating">
                <strong>Vaše hodnocení</strong>
                <div class="stars-wrapper">
                    ${starsHtml}
                </div>
            </div>
        </div>
    `;
    $.colorbox({
        html: content,
        width: "500px",
        maxWidth: "95%",
        className: "rating-colorbox"
    });
});*/
/*
$('#p-detail-tabs').on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();

    var target = $(this.getAttribute('href'));

    if (target.length) {
        $('html, body').animate({
            scrollTop: target.offset().top - 135
        }, 400);
    }
});
*/
function slugify(text) {
  return text
    .toLowerCase()
    .normalize('NFD')                 // odstraní diakritiku
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/[^a-z0-9]+/g, '-')      // mezery → -
    .replace(/^-+|-+$/g, '')
    .replace(/[0-9]/g, '')            // pryč čísla
    .replace(/["”“″',.]/g, '')
}

$(function () {
    const $tabsRow = $('.shp-tabs-row.responsive-nav');

    if (!$tabsRow.length) {
        return;
    }

    let tabsStickyStart = 0;
    let tabsNormalHeight = 0;
    let tabsStickyHeight = 0;
    let map = [];

    const stickyExtraOffset = 20;
    const beforeStickyExtraOffset = 100;

    const $placeholder = $('<div class="stickyTabsPlaceholder"></div>')
        .hide()
        .insertBefore($tabsRow);

    function measureTabs() {
        const wasSticky = $tabsRow.hasClass('stickyTabs');

        $tabsRow.removeClass('stickyTabs');
        $placeholder.hide().height(0);

        tabsStickyStart = $tabsRow.offset().top;
        tabsNormalHeight = $tabsRow.outerHeight();

        $tabsRow.addClass('stickyTabs');
        tabsStickyHeight = $tabsRow.outerHeight();

        if (wasSticky) {
            $tabsRow.addClass('stickyTabs');
            $placeholder.height(tabsNormalHeight).show();
        } else {
            $tabsRow.removeClass('stickyTabs');
            $placeholder.hide().height(0);
        }
    }

    function updateStickyTabs() {
        if ($(window).scrollTop() >= tabsStickyStart) {
            $placeholder.height(tabsNormalHeight).show();
            $tabsRow.addClass('stickyTabs');
        } else {
            $tabsRow.removeClass('stickyTabs');
            $placeholder.hide().height(0);
        }
    }

    function getScrollOffset(targetTop) {
        const tabsAreSticky = $tabsRow.hasClass('stickyTabs');
        const tabsWillBeSticky = targetTop >= tabsStickyStart;

        if (tabsAreSticky) {
            return tabsStickyHeight + stickyExtraOffset;
        }

        if (tabsWillBeSticky) {
            return tabsStickyHeight + beforeStickyExtraOffset;
        }

        return beforeStickyExtraOffset;
    }

    function rebuildMap() {
        map = [];

        $('#p-detail-tabs .shp-tab-link').each(function () {
            const $link = $(this);
            const id = $link.attr('href');

            if (!id || !id.startsWith('#')) {
                return;
            }

            const $section = $(id);

            if ($section.length) {
                map.push({
                    $tab: $link.closest('.shp-tab'),
                    $section: $section
                });
            }
        });
    }

    function updateActiveTabs() {
        if (!map.length) {
            rebuildMap();
        }

        const triggerPoint = getScrollOffset($(window).scrollTop()) + 40;

        $.each(map, function (_, item) {
            const rect = item.$section[0].getBoundingClientRect();

            if (rect.top <= triggerPoint && rect.bottom >= triggerPoint) {
                $('#p-detail-tabs .shp-tab').removeClass('activeTabs');
                item.$tab.addClass('activeTabs');
            }
        });
    }

    $('html')
        .off('click.detailTabsAnchor')
        .on('click.detailTabsAnchor', '#p-detail-tabs .shp-tab-link', function (e) {
            const id = $(this).attr('href');

            if (!id || !id.startsWith('#')) {
                return;
            }

            const $section = $(id);

            if (!$section.length) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            measureTabs();
            rebuildMap();

            const targetTop = $section.offset().top;
            const offset = getScrollOffset(targetTop);
            const finalTop = targetTop - offset;


            $('html, body').stop(true, false).animate({
                scrollTop: finalTop
            }, 300);

            $('#p-detail-tabs .shp-tab').removeClass('activeTabs');
            $(this).closest('.shp-tab').addClass('activeTabs');

            return false;
        });

    $(window)
        .off('scroll.detailTabsSticky resize.detailTabsSticky')
        .on('scroll.detailTabsSticky', function () {
            updateStickyTabs();
            updateActiveTabs();
        })
        .on('resize.detailTabsSticky', function () {
            measureTabs();
            updateStickyTabs();
            updateActiveTabs();
        });

    measureTabs();
    rebuildMap();
    updateStickyTabs();
    updateActiveTabs();

    setTimeout(function () {
        measureTabs();
        rebuildMap();
        updateStickyTabs();
        updateActiveTabs();
    }, 700);

    $(window).on('load', function () {
        measureTabs();
        rebuildMap();
        updateStickyTabs();
        updateActiveTabs();
    });
});

function parsePriceUniversal(val) {
    if (typeof val === 'number') return val;
    if (!val) return 0;

    val = val.toString().replace(/\s/g, '');

    if (val.includes(',') && val.includes('.')) {
        if (val.lastIndexOf(',') > val.lastIndexOf('.')) {
            val = val.replace(/\./g, '').replace(',', '.');
        } else {
            val = val.replace(/,/g, '');
        }
    } else if (val.includes(',')) {
        val = val.replace(',', '.');
    }

    return parseFloat(val) || 0;
}


var $priceFinal = $('.price-final-holder');
var $priceAdditional = $('.price-additional');
var $priceStandard = $('.price-standard span');
var isVatFree = $priceAdditional.text().includes(translation('osvobozeno'));
if ($priceStandard.length && !$priceStandard.data('base')) {
    var base = parsePriceUniversal($priceStandard.text());

    // fallback ochrana
    if (!base || base === 0) {
        console.warn('⚠️ price-standard nenalezen nebo 0');
    }

    $priceStandard.data('base', base);
}


// ✅ uložíme base ceny JEDNOU a správně
if (!$priceFinal.data('base')) {
    $priceFinal.data('base', parsePriceUniversal($priceFinal.text()));
}

if (!$priceAdditional.data('base')) {
    $priceAdditional.data(
        'base',
        parsePriceUniversal(
            $priceAdditional.clone().children().remove().end().text()
        )
    );
}

function updatePrice() {
    var baseFinal = $priceFinal.data('base');
    var baseAdditional = $priceAdditional.data('base');
    var baseStandard = $priceStandard.length ? $priceStandard.data('base') : 0;

    var extraWithVat = 0;
    var extraWithoutVat = 0;

    $('.acc-product.activeAcc').each(function () {
        var price = parsePriceUniversal($(this).data('price'));

        extraWithVat += price;
        extraWithoutVat += price / (1 + VAT);
    });

    var newFinal = baseFinal + extraWithVat;
    var newAdditional = baseAdditional + extraWithoutVat;
    var newStandard = baseStandard + extraWithVat;

    // FINAL
    $priceFinal.text(newFinal.ShoptetFormatAsCurrency());

    // BEZ DPH
    if (isVatFree) {
        $priceAdditional.text(translation('osvobozeno'));
    } else {
        $priceAdditional.contents().first()[0].textContent =
            newAdditional.ShoptetFormatAsCurrency() + ' ' + translation('bezDPH');
    }

    // STANDARD
    if ($priceStandard.length) {
        $priceStandard.text(newStandard.ShoptetFormatAsCurrency());
    }
}
function priceWithoutVat(priceWithVat) {
    return priceWithVat / (1 + VAT);
}

function initRepasSlider(){
    $('.repas .repasInner').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
        autoplay: false,
        autoplaySpeed: 5000,
        dots: true,
        arrows: true,
        infinite: false,
        adaptiveHeight: false,
        responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 4.4, slidesToScroll: 1 } }, 
        { breakpoint: 992, settings: { slidesToShow: 3.4, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 2.4, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1.8, slidesToScroll: 1 } }
        ]
    });
}

/*
$(document).on('mouseenter', '.customStar', function () {
  const rating = Number($(this).data('score'));
  const $wrap = $(this).closest('.customStarsWrap');
  const $box = $(this).closest('.colorboxPopupRatings');

  $wrap.find('.customStar').each(function () {
    const starRating = Number($(this).data('score'));
    $(this).toggleClass('isHover', starRating <= rating);
  });

  $box.find('.customStarsText').text(ratingTexts[rating]);
});

$(document).on('mouseleave', '.customStarsWrap', function () {
  const $wrap = $(this);
  const $box = $wrap.closest('.colorboxPopupRatings');
  const selectedRating = Number($wrap.attr('data-selected-rating')) || 0;

  $wrap.find('.customStar').removeClass('isHover');

  if (selectedRating > 0) {
    $box.find('.customStarsText').text(ratingTexts[selectedRating]);
  } else {
    $box.find('.customStarsText').text('Vyberte hodnocení');
  }
});*/



$('html').on('click', '.colorboxPopupRatings .customStarsWrap .customStar', function (e) {
  e.preventDefault();

  const $star = $(this);
  const $wrap = $star.closest('.customStarsWrap');
  const score = Number($star.data('score'));

  $wrap.attr('data-selected-rating', score);

  $wrap.find('.customStar').each(function () {
    const starScore = Number($(this).data('score'));
    $(this).toggleClass('isActive', starScore <= score);
  });

const successCallback = function (response) {
  $('.product-top .stars-wrapper').html(response.getPayload());

  $('.product-top .stars-wrapper')
    .attr('data-can-rate', '0')
    .find('.productRatingAction')
    .removeClass('productRatingAction');

  initTooltips();

  $('.colorboxPopupRatings .customStarsText').text('Děkujeme za hodnocení.');

  setTimeout(function () {
    $.colorbox.close();
  }, 800);
};

  const dataString = 'productId=' + $star.data('productid') + '&score=' + score;

  shoptet.ajax.makeAjaxRequest(
    shoptet.config.rateProduct,
    shoptet.ajax.requestTypes.post,
    dataString,
    {
      success: successCallback
    },
    {
      'X-Shoptet-XHR': 'Shoptet_Coo7ai'
    }
  );

  return false;
});


document.addEventListener('shoptet.modal.open', function () {
    $('body').addClass('shoptetModalOpen');
});


function initShoptetModalStateClass() {
    if (window.shoptetModalStateClassInitialized) return;
    window.shoptetModalStateClassInitialized = true;

    function removeModalClass() {
        $('body').removeClass('shoptetModalOpen');
    }

    function checkModalState() {
        const isOpen = $('#colorbox:visible, #cboxOverlay:visible').length > 0;

        if (!isOpen) {
            removeModalClass();
        }
    }

    if (window.shoptet && shoptet.modal && typeof shoptet.modal.open === 'function') {
        const originalOpen = shoptet.modal.open;

        shoptet.modal.open = function () {
            $('body').addClass('shoptetModalOpen');

            return originalOpen.apply(this, arguments);
        };
    }

    $(document)
        .on('cbox_closed.shoptetModalState cbox_cleanup.shoptetModalState', function () {
            removeModalClass();
        });

    $(document).on('click.shoptetModalState', '#cboxClose, #cboxOverlay', function () {
        setTimeout(checkModalState, 50);
        setTimeout(checkModalState, 250);
    });

    $(document).on('keyup.shoptetModalState', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            setTimeout(checkModalState, 50);
            setTimeout(checkModalState, 250);
        }
    });
}

initShoptetModalStateClass();

$(function () {
    const $tabs = $('#p-detail-tabs');

    if (!$tabs.length || $tabs.parent('.pDetailTabsScroll').length) {
        return;
    }

    $tabs.wrap('<div class="pDetailTabsScroll"></div>');

    const $wrap = $tabs.parent();
    $wrap.append('<div class="pDetailTabsBar"><span></span></div>');

    const $bar = $wrap.find('.pDetailTabsBar');
    const $thumb = $bar.find('span');

    function updateTabsScrollbar() {
        const el = $tabs[0];
        const scrollWidth = el.scrollWidth;
        const clientWidth = el.clientWidth;
        const scrollLeft = el.scrollLeft;

        if (scrollWidth <= clientWidth) {
            $bar.hide();
            return;
        }

        $bar.show();

        const thumbWidth = Math.max((clientWidth / scrollWidth) * clientWidth, 160);
        const maxLeft = clientWidth - thumbWidth;
        const left = (scrollLeft / (scrollWidth - clientWidth)) * maxLeft;

        $thumb.css({
            width: thumbWidth + 'px',
            transform: 'translateX(' + left + 'px)'
        });
    }

    $tabs.on('scroll', updateTabsScrollbar);
    $(window).on('resize', updateTabsScrollbar);

    updateTabsScrollbar();
});

$(document).on('click', '.p-detail-info .stars-wrapper', function (e) {
    e.preventDefault();

    const $target = $('#tab-content #ratingTab');
   

    if ($target.length) {
         const offset = window.innerWidth >= 768 ? 220 : 80;
        $('html, body').animate({
            scrollTop: $target.offset().top - offset
        }, 500);
    }
});


function normalizeSkuItem(item) {
    if (typeof item === 'string') {
        return {
            sku: item,
            url: null
        };
    }

    return {
        sku: item.sku,
        url: item.url || null
    };
}

function findProductTabSkuConfig(tabConfig, sku) {
    if (!tabConfig || !Array.isArray(tabConfig.skus)) {
        return null;
    }

    const found = tabConfig.skus
        .map(normalizeSkuItem)
        .find(function (item) {
            return item.sku === sku;
        });

    return found || null;
}

$('html').on('click', '.acc-product-popup-info', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const url = $(this).data('url');

    if (!url) {
        return;
    }

    $.get(url, function (response) {
        const $html = $('<div>').append($.parseHTML(response));
        const $content = $html.find('.content-inner .text').first();

        let popupHtml = '';

        if ($content.length) {
            popupHtml = $content.html();
        } else {
            popupHtml = '<p>' + translation('nepodarilosenacist') + '</p>';
        }

        $.colorbox({
            html: `
                <div class="accProductPopup">
                    ${popupHtml}
                </div>
            `,
            width: 600,
            maxWidth: '95%',
            maxHeight: '90%',
            className: 'accProductInfoPopup',
            onComplete: function () {
                $('body').addClass('shoptetModalOpen');
                $.colorbox.resize();
            }
           
        });

    }).fail(function () {

        $.colorbox({
            html: `
                <div class="accProductPopup">
                    <p>${translation('nepodarilosenacist')}</p>
                </div>
            `,
            width: 760,
            maxWidth: '95%',
            maxHeight: '90%',
            className: 'accProductInfoPopup',
            onComplete: function () {
                $.colorbox.resize();
            }
        });

    }).onClose(function(){
        $('body').remove('shoptetModalOpen');
    });
});



if($('#formRating').length){
    $('#formRating').prepend('<div class="h3">'+translation('pridatHodnoceni')+'</div>');
    $('#formRating input[id="name"], #formRating input[id="email"]').closest('.form-group').addClass('half');
    $('#formRating .rating-stars-wrapper').prepend('<p>'+translation('vaseHodnoceni')+'</p>');
    $('#formRating').append('<span class="close"></span>');
    $('#formRating button.btn-primary.btn-sm').text(translation('pridatHodnoceni'));
    $('#formRating label[for="message"]').text(translation('spokojenost'))

}

$('html').on('click', 'button[data-testid="buttonAddRating"]', function(){
    $('body').addClass('shoptetModalOpen');
})

$('html').on('click', '#rate-form .close', function (e) {
    e.preventDefault();

    $('#rate-form').removeClass('visible');
    $('#ratingWrapper').removeClass('unveiled');
    $('body').removeClass('shoptetModalOpen');
});


$(document).on('click', '#rate-form.visible', function (e) {

    if ($(e.target).closest('#formRating').length) {
        return;
    }

    $('#rate-form').removeClass('visible');
    $('#ratingWrapper').removeClass('unveiled');
    $('body').removeClass('shoptetModalOpen');
});


$(document).on('mouseenter', '.rating-stars-wrapper .rating-star', function () {
    const $current = $(this);

    $current
        .prevAll('.rating-star')
        .addBack()
        .addClass('fullStar');

    $current
        .nextAll('.rating-star')
        .removeClass('fullStar');
});

$(document).on('mouseleave', '.rating-stars-wrapper', function () {
    $(this).find('.rating-star').removeClass('fullStar');
});

$(document).on('focus click', 'textarea[data-testid="inputRatingDescription"]', function () {
    $('.form-group.focused').removeClass('focused');
    $(this).closest('.form-group').addClass('focused');
});

$(document).on('click', function (e) {
    if (!$(e.target).closest('textarea[data-testid="inputRatingDescription"]').length) {
        $('textarea[data-testid="inputRatingDescription"]').closest('.form-group').removeClass('focused');
    }
});